<template>
  <div>
    <GoogleFont/>
  </div>
</template>

<script>

import GoogleFont from "@/components/SideEditor/BlockConfiguration/TypographyConfig/GoogleFont"

export default {
  components: {
    GoogleFont,
  },
}

</script>
